export function reportReactError(error, errorInfo) {
    const { componentStack, errorBoundary } = errorInfo ?? {};
    const { lang, className } = document.documentElement;

    const context = {
        boundary: errorBoundary?.constructor?.name ?? null,
        // Translators and similar injected tools rewrite text nodes into <font> wrappers.
        hasFontWrappers: Boolean(document.querySelector('font')),
        documentLang: lang,
        documentClassName: className
    };

    console.error(`[React] ${JSON.stringify(context)}`, error, componentStack ?? '');
}
